/* eslint-disable max-len */
import Constants from '../utils/Constants';
import convertPrice from './convertPrice';
import getCentAmount from '../utils/getCentAmount';

/**
 * Return product data by country
 *
 * @param {array} lineItems of products
 * @param {boolean} isConvertedPrice
 * @param {boolean} isToShowProducts
 * @returns {array} products
 */
function useProductDataByCountry(
  lineItems,
  isConvertedPrice,
  isToShowProducts,
) {
  const { isMexico, isColombia } = Constants;
  const products = [];

  const language = (name) => {
    let nameByCountry;
    if (isMexico) nameByCountry = name['es-MX'];
    else if (isColombia) nameByCountry = name['es-CO'];
    else nameByCountry = name.en;
    return nameByCountry;
  };

  if (!isToShowProducts) {
    lineItems.forEach((productsArr) => {
      productsArr.forEach((product) => {
        const { images } = product.variant;
        const centAmount = getCentAmount(product);
        if (product.discountedPricePerQuantity.length === 0) {
          const productsConvert = {
            id: product.id,
            productId: product.productId,
            name: language(product.name),
            price: isConvertedPrice ? convertPrice(centAmount) : centAmount,
            quantity: product.quantity,
            totalPrice: isConvertedPrice
              ? convertPrice(centAmount * product.quantity)
              : centAmount * product.quantity,
            images,
          };
          products.push(productsConvert);
        } else {
          const {
            centAmount: centAmountDiscounted,
          } = product.discountedPricePerQuantity[0].discountedPrice.value;
          const productsConvert = {
            id: product.id,
            productId: product.productId,
            name: language(product.name),
            price: isConvertedPrice
              ? convertPrice(centAmountDiscounted)
              : centAmountDiscounted,
            quantity: product.quantity,
            totalPrice: isConvertedPrice
              ? convertPrice(centAmount * product.quantity)
              : centAmount * product.quantity,
            images,
          };
          products.push(productsConvert);
        }
      });
    });
  } else {
    lineItems.forEach((productsArr) => {
      productsArr.forEach((product) => {
        const { images } = product.variant;
        const { centAmount } = product.price.value;
        const productsConvert = {
          id: product.id,
          productId: product.productId,
          name: language(product.name),
          price: isConvertedPrice
            ? convertPrice(Number(centAmount / 100).toFixed(2))
            : centAmount / 100,
          quantity: product.quantity,
          totalPrice: isConvertedPrice
            ? convertPrice(Number((centAmount / 100)).toFixed(2))
            : (centAmount / 100),
          images,
          principalPrice: product.price.discounted
            ? convertPrice(Number((product.price.discounted.value.centAmount / 100) * product.quantity)
              .toFixed(2))
            : convertPrice(Number((product.price.value.centAmount / 100) * product.quantity)
              .toFixed(2)),
          hasDiscount: !!product.price.discounted,
        };
        products.push(productsConvert);
      });
    });
  }

  return products;
}

export default useProductDataByCountry;
